// Google Analytics 4 (gtag.js) for a single-page app.
// The Measurement ID lives in REACT_APP_GA_MEASUREMENT_ID. Auto page_view is
// disabled so we can send one pageview per client-side route change.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const GA_ENABLED = !!GA_ID;

export function initGA() {
  if (!GA_ID || typeof window === 'undefined' || window.__gaInitDone) return;
  window.__gaInitDone = true;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!GA_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
